module.exports = __webpack_public_path__ + "img/zhangshaojun.6246533f.png";